import React from 'react';

export default function Footer(props) {
  return <footer></footer>;
}
